import { render, staticRenderFns } from "./AuthorPosterForm.vue?vue&type=template&id=1c6b4a6c&"
import script from "./AuthorPosterForm.vue?vue&type=script&lang=js&"
export * from "./AuthorPosterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports